import { Checkbox } from './Checkbox'
import { Country } from './Country'
import { DayPicker } from './DayPicker'
import { Email } from './Email'
import { Message } from './Message'
import { MultiCheck } from './MultiCheck'
import { Number } from './Number'
import { Radio } from './Radio'
import { Select } from './Select'
import { State } from './State'
import { Text } from './Text'
import { Textarea } from './Textarea'
import { Upload } from './Upload'

export const fields = {
  checkbox: Checkbox,
  country: Country,
  // Form builder block slug is 'dateBlock'; keep 'date' for legacy seeded forms
  dateBlock: DayPicker,
  date: DayPicker,
  email: Email,
  message: Message,
  number: Number,
  radioBlock: Radio,
  select: Select,
  state: State,
  text: Text,
  textarea: Textarea,
  multiCheckBlock: MultiCheck,
  // Form builder uses block slug as blockType; upload block slug is 'uploadBlock'
  uploadBlock: Upload,
}
